module.exports = __webpack_public_path__ + "static/assets/f5cc8a2daf29f7c4440b1f64482e531e.png";